import IndustryPageTemplate from "./IndustryPageTemplate";
import { medSpasData } from "@/data/medSpas";

export default function MedSpasPage() {
  return <IndustryPageTemplate data={medSpasData} />;
}
